const GATEWAY_LANGUAGE_PARAM = 'gatewayLanguage';
const GATEWAY_INTL_PARAM = 'gatewayIntl';

const getCookie = (cookie, name) => {
    const item = cookie.split('; ').find((value) => value.startsWith(`${name}=`));

    return item ? decodeURIComponent(item.split('=').slice(1).join('=')) : '';
};

export const getGatewayLanguageParams = ({
    search = window.location.search,
    cookie = document.cookie,
} = {}) => {
    const query = new URLSearchParams(search);

    return {
        gatewayLanguage:
            query.get(GATEWAY_LANGUAGE_PARAM) || getCookie(cookie, 'gateway-language'),
        gatewayIntl: query.get(GATEWAY_INTL_PARAM) || getCookie(cookie, 'gateway-intl'),
    };
};

const appendGatewayLanguageParams = (searchParams, options) => {
    const { gatewayLanguage, gatewayIntl } = getGatewayLanguageParams(options);

    if (gatewayLanguage) searchParams.set(GATEWAY_LANGUAGE_PARAM, gatewayLanguage);
    if (gatewayIntl) searchParams.set(GATEWAY_INTL_PARAM, gatewayIntl);
};

export const getGatewayNavigationPath = (pathname, options) => {
    const searchParams = new URLSearchParams();
    appendGatewayLanguageParams(searchParams, options);
    const search = searchParams.toString();

    return search ? `${pathname}?${search}` : pathname;
};

export const buildInvitationLink = ({
    room,
    origin = window.location.origin,
    pathname = window.location.pathname,
    search = window.location.search,
    cookie = document.cookie,
}) => {
    let appBasePath = pathname.replace(/\/+$/, '');

    if (appBasePath.endsWith('/app')) {
        appBasePath = appBasePath.slice(0, -4);
    }

    const invitationPath = `${appBasePath}/invitation`.replace(/^([^/])/, '/$1');
    const invitationUrl = new URL(invitationPath || '/invitation', origin);
    invitationUrl.searchParams.set('room', room);
    appendGatewayLanguageParams(invitationUrl.searchParams, { search, cookie });

    return invitationUrl.toString();
};
